<div class="modal-header">
  <h4 class="modal-title pull-left">
    <span *ngIf="currentFlow === getAddUserFlow()">{{'Add user' | translate}}</span>
    <span *ngIf="currentFlow === getEditUserFlow()">{{'Edit user' | translate}}</span>
    - {{'roles selection' | translate}}
  </h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="rolesModalRef.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">

  <p>{{'Please select the roles of the user' | translate}}</p>

  <form [formGroup]="rolesForm" class="ng" fxLayout="column" novalidate>

    <div class="form-group" fxLayout fxLayout.xs="column">
      <label class="control-label" fxFlex="30">
        {{'Roles' | translate}}
      </label>
      <div class="input-container" fxLayout="column" fxFlex>
        <ng-select
          [items]="listOfRoles"
          bindLabel="label"
          bindValue="value"
          [multiple]="true"
          [closeOnSelect]="false"
          [clearable]="true"
          notFoundText="{{'No results found' | translate}}"
          formControlName="roles">
          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <div class="ng-value" *ngFor="let item of items | slice:0:15">
                <span class="ng-value-label">{{item.label}}</span>
                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
            </div>
            <div class="ng-value" *ngIf="items.length > 15">
                <span class="ng-value-label">{{items.length - 15}} {{'more' | translate}}...</span>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>

  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-info" (click)="goToNextStep()" [ngStyle]="{'width': '100%'}"
          [disabled]="rolesForm.invalid">
    {{'Forward' | translate}}
  </button>

</div>
